module.exports = __webpack_public_path__ + "static/media/research_icon.83dd2fc4.svg";